export default function AcceptableUseContent() {
  return (
    <>
      <p>
        <strong>Last updated:</strong> November 14, 2025
      </p>
      <p>
        This Acceptable Use Policy governs all use of the Lutely website,{" "}
        <a href="https://lutely.com" target="_blank" rel="noopener noreferrer">
          https://lutely.com
        </a>
        , and the Lutely Software-as-a-Service application (the "
        <strong>Platform</strong>") offered by License Lounge, Inc., a Delaware
        corporation, d/b/a Lutely ("<strong>Lutely</strong>", "
        <strong>we</strong>", "<strong>us</strong>", or "<strong>our</strong>").
      </p>
      <p>
        This Acceptable Use Policy may change from time to time.{" "}
        <strong>
          Your continued use of the Platform after any modification means that
          you acknowledge the change and agree to the practices that we disclose
          in the Acceptable Use Policy.
        </strong>{" "}
        If you do not agree with our policies and practices, then please do not
        use our Platform.
      </p>
      <p>
        This Acceptable Use Policy makes reference to our Terms of Use, as we
        may amend that document from time to time. In this Acceptable Use
        Policy, the terms "Content," "License," "Your Content," and any other
        capitalized but undefined terms have the meanings given in our Terms of
        Use.
      </p>
      <p>
        The content standards herein apply to any and all: (a) use of the
        Platform; (b) Content, including Your Content; and (c) submissions by
        you to the Platform, including but not limited to posts, comments, and
        interactions on message boards, chat rooms, personal web pages or
        profiles, forums, bulletin boards, listings, and other interactive
        features ("<strong>User Contributions</strong>"). Your Content and User
        Contributions must in their entirety comply with all applicable federal,
        state, local, and international laws and regulations. Without limiting
        the foregoing, your use of the Platform, Your Content, and User
        Contributions must not:
      </p>
      <ul>
        <li>
          Contain any material that is defamatory, obscene, indecent, abusive,
          offensive, harassing, violent, hateful, inflammatory, or otherwise
          objectionable.
        </li>
        <li>
          Promote sexually explicit or pornographic material, violence, or
          discrimination based on race, sex, religion, nationality, disability,
          sexual orientation, or age.
        </li>
        <li>
          Infringe any patent, trademark, trade secret, copyright, or other
          intellectual property or other rights of any other person.
        </li>
        <li>
          Violate the legal rights (including the rights of publicity and
          privacy) of others or contain any material that could give rise to any
          civil or criminal liability under applicable laws or regulations or
          that otherwise may be in conflict with our Terms of Use and our
          Privacy Policy.
        </li>
        <li>Be likely to deceive any person.</li>
        <li>
          Promote any illegal activity, or advocate, promote, or assist any
          unlawful act.
        </li>
        <li>
          Cause annoyance, inconvenience, or needless anxiety or be likely to
          upset, embarrass, alarm, or annoy any other person.
        </li>
        <li>
          Impersonate any person or misrepresent your identity or affiliation
          with any person or organization.
        </li>
        <li>
          Involve commercial activities or sales, such as contests, sweepstakes,
          and other sales promotions, barter, or advertising, except as
          connected to any Licenses offered through the Platform.
        </li>
        <li>
          Give the impression that they emanate from or are endorsed by us or
          any other person or entity, if this is not the case.
        </li>
      </ul>
      <p>
        Lutely may, in its sole discretion and for any reason, delete Your
        Content from the Platform, delete your User Contributions from the
        Platform, or terminate your access to Free Features. Lutely may also
        terminate your Subscription, as governed by the "Term and Termination"
        section of the Terms of Use, if Lutely determines, in its sole
        discretion, that you have violated any term of this Acceptable Use
        Policy.
      </p>
      <p>
        Please direct any questions about this Acceptable Use Policy to{" "}
        <a href="mailto:info@lutely.com">info@lutely.com</a>. All notices of
        copyright infringement claims should be sent to the copyright agent
        designated in our DMCA Policy in the manner and by the means set out
        therein.
      </p>
    </>
  );
}
